import type { CreateExamFormValues } from "./CreateExamForm";
import { useFormContext } from "react-hook-form";
import { SelectArrayInput } from "react-admin";
import { BookedTraining } from "../../model/BookedTraining";

export function TheoryExamTrainingSelector(props: { activeBookedTrainings: BookedTraining[] }) {
  const { activeBookedTrainings } = props;
  const { setValue } = useFormContext<CreateExamFormValues>();
  const choices = activeBookedTrainings.map((it) => ({ id: it.id, name: `Klasse ${it.drivingLicenseClass}` }));
  return (
    <SelectArrayInput
      source="bookedTrainingIds"
      label="Prüfung für"
      choices={choices}
      onChange={(event) => {
        const ids = event.target.value as string[];
        // Preserve the order of `activeBookedTrainings` so the display stays stable.
        const activeIdSet = new Set(ids);
        const ordered = activeBookedTrainings.filter((it) => activeIdSet.has(it.id)).map((it) => it.id);
        if (ordered.join(",") !== ids.join(",")) {
          setValue("bookedTrainingIds", ordered);
        }
      }}
      helperText={false}
      data-testid="theory-exam-coverage-selector"
    />
  );
}
